import { render, staticRenderFns } from "./OssIndexAnalyzer.vue?vue&type=template&id=4564abd2&"
import script from "./OssIndexAnalyzer.vue?vue&type=script&lang=js&"
export * from "./OssIndexAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4564abd2')) {
      api.createRecord('4564abd2', component.options)
    } else {
      api.reload('4564abd2', component.options)
    }
    module.hot.accept("./OssIndexAnalyzer.vue?vue&type=template&id=4564abd2&", function () {
      api.rerender('4564abd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/analyzers/OssIndexAnalyzer.vue"
export default component.exports